import type { TranslationDictionary } from '../types';
import en from './en';
import es from './es';
import it from './it';

export const dictionaries: Record<string, TranslationDictionary> = {
	en,
	es,
	it
};

export const tenantDictionaries: Record<string, TranslationDictionary> = {};
